<template>
  <div class="card h-full">
    <!-- este h-full es clave -->
    <div
      class="text-sm gap-0.5 bg-white text-text-primary dark:text-text-primary-dark border border-dark-secondary rounded-md p-3 shadow-2xs flex flex-col justify-between h-full dark:bg-background-alt dark:border-dark-border"
    >
      <p
        class="font-500 text-[13px] leading-4 tracking-[-0.2px]"
        :class="classStyle"
      >
        Observación
      </p>
      <Textarea
        :disabled="isDisabled"
        v-model="data.observationAnalyst"
        size="small"
        placeholder="Escriba su mensaje aquí..."
        :rows="rowSlot"
        class="h-full"
        cols="20"
        :style="disabledStyle"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isAnalist: {
    type: Boolean,
    default: false,
  },
});

const isDisabled = computed(() => {
  return !(
    props.data.statusType.description !== "Rechazado" &&
    (props.data.status.description === "Pendiente" ||
      props.data.status.description === "Corregido")
  );
});

const rowSlot = computed(() => {
  let resultRowdata;
  if (props.data.operationType === 1) {
    if (props.data.status.description === "Corregido") {
      resultRowdata = 23;
    } else if (props.data.status.description === "En Corrección") {
      props.isAnalist ? (resultRowdata = 15) : (resultRowdata = 14);
    } else if (props.data.status.id == 8 || props.data.status.id == 9) {
      resultRowdata = 16;
    } else {
      resultRowdata = 17;
    }
  } else if (props.data.operationType === 2) {
    if (props.data.status.id == 8 || props.data.status.id == 9) {
      resultRowdata = 12;
    } else {
      resultRowdata = 13;
    }
  } else if (props.data.operationType === 3 || props.data.operationType === 5) {
    if (props.data.status.description === "Corregido") {
      resultRowdata = 18;
    } else if (props.data.status.description === "En Corrección") {
      resultRowdata = 11;
    } else if (props.data.status.id == 8 || props.data.status.id == 9) {
      resultRowdata = 11;
    } else {
      resultRowdata = 13;
    }
  } else if (props.data.operationType === 4 || props.data.operationType === 6) {
    resultRowdata = 4;
  }

  return resultRowdata;
});
const disabledStyle = computed(() => {
  return isDisabled.value
    ? {
        backgroundColor: "#D7DDE2",
        color: "#7a92a1",
        cursor: "not-allowed",
      }
    : {};
});

const classStyle = computed(() => {
  if (props.data.operationType === 1) {
    if (props.data.status.description === "Corregido") {
      return "mb-2";
    } else if (props.data.status.description === "En Corrección") {
      return props.isAnalist ? "mb-4" : "mt-2 mb-5";
    } else if (props.data.status.id == 8 || props.data.status.id == 9) {
      return "";
    } else {
      return "mt-5.5 mb-1";
    }
  } else if (props.data.operationType === 2) {
    if (props.data.status.id == 8 || props.data.status.id == 9) {
      return "mt-2 mb-2";
    } else {
      return "mt-3";
    }
  } else if (props.data.operationType === 3 || props.data.operationType === 5) {
    if (props.data.status.description === "Corregido") {
      return "mt-4 mb-2";
    } else if (props.data.status.description === "En Corrección") {
      return props.isAnalist ? "mt-2 mb-2" : "mt-1 mb-2";
    } else if (props.data.status.id == 8 || props.data.status.id == 9) {
      return "mt-2 mb-2";
    } else {
      return "mt-2 mb-4";
    }
  } else if (props.data.operationType === 4 || props.data.operationType === 6) {
  }
  if (props.data.status.description === "En Corrección") {
    return "mt-1 mb-2";
  } else if (props.data.status.id == 8 || props.data.status.id == 9) {
    return "";
  } else {
    return "mt-3";
  }
});
</script>
